import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-36c50d6c"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "max-w-5xl mx-auto" };
const _hoisted_2 = { class: "flex flex-col my-1" };
const _hoisted_3 = { class: "flex flex-row my-2" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", { class: "btn-register btn-red" }, "管理者を登録", -1));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("button", { class: "btn-register btn-red" }, "CSV出力", -1));
const _hoisted_7 = [
    _hoisted_6
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Title = _resolveComponent("Title");
    const _component_router_link = _resolveComponent("router-link");
    const _component_Form = _resolveComponent("Form");
    const _component_Table = _resolveComponent("Table");
    const _directive_tooltip = _resolveDirective("tooltip");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Title, {
            msg: "ユーザ一覧",
            submsg: "User List"
        }),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                ($data.isSysAdmin)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(_component_router_link, {
                            to: "/user/register",
                            id: "user-register",
                            class: "mr-5"
                        }, {
                            default: _withCtx(() => [
                                _hoisted_5
                            ]),
                            _: 1
                        })
                    ]))
                    : _createCommentVNode("", true),
                (!$data.isAdminList && $data.isSysAdmin)
                    ? _withDirectives((_openBlock(), _createElementBlock("div", {
                        key: 1,
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => ($options.csvDownload && $options.csvDownload(...args))),
                        class: "inline-block"
                    }, _hoisted_7)), [
                        [_directive_tooltip, {
                                content: '現在の検索結果でプッシュ通知対象CSVを出力します(未検索の場合は全件取得)',
                            }]
                    ])
                    : _createCommentVNode("", true)
            ])
        ]),
        _createVNode(_component_Form, {
            requestsList: _ctx.requestsList,
            isSysAdmin: $data.isSysAdmin,
            administratorHandleSearch: $options.searchAdministrator,
            customerHandleSearch: $options.searchCustomer,
            changeUserListType: $options.changeUserListType,
            isAdminList: $data.isAdminList
        }, null, 8, ["requestsList", "isSysAdmin", "administratorHandleSearch", "customerHandleSearch", "changeUserListType", "isAdminList"]),
        _createVNode(_component_Table, {
            searchedCustomers: $data.searchedCustomers,
            searchedAdministrators: $data.searchedAdministrators,
            isSysAdmin: $data.isSysAdmin,
            deleteAdministrator: $options.deleteAdministrator,
            udapteCustomer: $options.udapteCustomer,
            isAdminList: $data.isAdminList
        }, null, 8, ["searchedCustomers", "searchedAdministrators", "isSysAdmin", "deleteAdministrator", "udapteCustomer", "isAdminList"])
    ]));
}
